// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  appId: '202ab71ec7b28f0b80c9fd543fc794f5',
  units: 'metric',
  // APIEndpoint: 'https://bosch-energyutilties-analytics.com',
  //'https://iep-test.southindia.cloudapp.azure.com',
  // APIEndpoint: 'http://sgpvmc0001.apac.bosch.com:8181',
  // APIEndpoint: 'http://localhost:8080',
  APIEndpoint: 'https://uapi.fof-fuso.com/emiam',
  APISuffixes: 'iep',
  loginUrl_SSO:"https://redirect.fof-fuso.com/emapp",
  logoutUrl_SSO:"https://login.microsoftonline.com/505cca53-5750-4134-9501-8d52d5df3cd1/oauth2/v2.0/logout",
  refresh_token_url: "https://uapi.fof-fuso.com/tokenrefresh/redirect/em",
  Version: 'v1',
  client_id: 'IEPEnergyWebClient',
  client_secret: '$2a$12$kUxzw1o/85lHoGnTIEpYoeb/55d4E.zHQUabm6NYqx97LzYFpI0V.',
  config: {
    tenantId: 'e01d2081-8764-4360-b95a-d4b7cdaca914',
    clientId: '40bcf5b1-f630-49ce-a7d9-066e6077aad1',
    redirectUri: 'https://bosch-energyutilties-analytics.com',
    cacheLocation: 'localStorage',
    endpoints: 'https://bosch-energyutilties-analytics.com'
    // popUp: true
  },
  // appConfig: {
  //   issuer: 'https://korvm075.apac.bosch.com:8443/auth/realms/fuso-test/',
  //   clientId: 'fusotestapp',
  //   responseType: 'code',
  //   scope: 'openid profile',
  //   clientSecret: '4b4c6189-4b31-4ec8-828c-ceb311d752e8',
  //   redirectUri: 'http://localhost:4200/login'
  // },
  appConfig: {
    issuer:
      'https://dfl:3d564dc7-cf64-4324-af44-038cd7b765c8@udfl-idm.fof-fuso.com/auth/realms/dfl/',
    clientId: 'ed3c1974',
    responseType: 'code',
    scope: 'openid profile',
    clientSecret: 'dd5a8f7525e5e2559a07c3b4dacecd20',
    redirectUri:
      'https://udfl-idm.fof-fuso.com/auth/realms/dfl/protocol/openid-connect/auth?client_id=ed3c1974&redirect_uri=https://uredirect.fof-fuso.com/callback/em&scope=openid&response_type=code%20token&response_mode=form_post&nonce=ao1ptmce7fn',
    logoutUrl:
      'https://udfl-idm.fof-fuso.com/auth/realms/dfl/protocol/openid-connect/logout?redirect_uri=https://sso.mercedes-benz.com/idp/startSLO.ping'
  },
  // Check and force logout if user idle for X minutes.
  userIdleTimeInMinutes: 30,
  // Production View
  productionViewUrl:
    'https://prod-progress.fof-fuso.com/production-progress/kawasaki'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
